import React, { useState } from 'react';
import { Modal } from 'semantic-ui-react';
import styles from '../styles/Q4ERemove.module.scss';
import { Button } from 'components/quashed';

const Q4ERemove = ({ onRemove }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleRemove = () => {
    setOpen(false);
    onRemove();
  };

  return (
    <Modal
      className={styles.modal}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      trigger={<div className={styles.toggle}>Remove workplace</div>}
      size="small"
    >
      <Modal.Content>
        <div className={styles.bold}>Removing your workplace</div>
        <div>
          This means you will no longer see your workplace insurance benefits,
          please check and update your policies or talk to an adviser if you
          want to explore your insurance options after leaving your workplace.
        </div>
        <Button
          className={styles.updateWorkBtn}
          text="Remove"
          onClick={handleRemove}
        />
      </Modal.Content>
    </Modal>
  );
};

export default Q4ERemove;
